import Grid from '@material-ui/core/Grid';

import styles from './BitGrid.style';

const BitGrid = ({ children, classes, className, ...props }) => (
  <Grid
    spacing={24}
    container
    className={classnames(classes.root, className)}
    {...props}>
    {children}
  </Grid>
);

BitGrid.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
};

export default withStyles(styles)(BitGrid);
